import React from "react";
import classnames from "classnames";
import { SuraLogo } from "@suralink/samurai/components";
import CompanyLogo from "./CompanyLogo";
import classes from "../../styles/CompanyLogo.module.scss";

const LogoHeader: React.FC<{
  showCompanyLogo: boolean;
  firmLogo?: string;
  firmName?: string;
}> = ({ showCompanyLogo, firmLogo, firmName }) => {
  const suraLogoSize = showCompanyLogo ? "md" : "lg";
  return (
    <div
      className={classnames(classes.logoHeader, {
        [classes.headerHasCompany]: showCompanyLogo,
      })}
    >
      <div
        className={classnames(classes.suraLogoWrapper, {
          [classes.withCompanyLogo]: showCompanyLogo,
        })}
      >
        <SuraLogo
          size={suraLogoSize}
          logoColor="blue"
          logoHasText
          textColor="dark"
        />
      </div>
      {showCompanyLogo && <CompanyLogo name={firmName} logoUrl={firmLogo} />}
    </div>
  );
};

export default LogoHeader;
